export function isProductParent(item) {
    if (!item) {
        return false;
    }
    return (typeof item === "object" &&
        "PK" in item &&
        typeof item.PK === "string" &&
        /^PRODUCT#/.test(item.PK) &&
        "type" in item &&
        typeof item.type === "string" &&
        Object.keys(ProductTypes).includes(item.type));
}
export function isProduct(item) {
    if (!item) {
        return false;
    }
    return (typeof item === "object" &&
        "PK" in item &&
        typeof item.PK === "string" &&
        /^PRODUCT#/.test(item.PK) &&
        "type" in item &&
        typeof item.type === "string" &&
        Object.keys(ProductTypes).includes(item.type));
}
export function isProductOption(item) {
    return (!!item &&
        typeof item === "object" &&
        "SK" in item &&
        typeof item.SK === "string" &&
        /OPTION#/.test(item.SK));
}
export const ProductTypes = {
    AnnualSponsorship: "Annual Sponsorship",
    CeremonyTicket: "Ceremony Ticket",
    HumpdayGiveaway: "Humpday Giveaway",
    VotingStageSponsorship: "Voting Stage Sponsorship",
    VoterRewards: "Voter Rewards",
    Magazine: "Magazine",
    MagazineDeposit: "Magazine Deposit",
    MagazineAd: "Magazine Ad",
    MagazineAdDeposit: "Magazine Ad Deposit",
    MagazineArticle: "Magazine Article",
    Plaque: "Plaque",
    Upgrade: "Upgrade",
};
export const ProductOptionTypes = {
    AnnualSponsorship: {
        SilverSponsorship: "Silver Sponsorship",
        GoldSponsorship: "Gold Sponsorship",
        PlatinumSponsorship: "Platinum Sponsorship",
    },
    CeremonyTicket: {
        GeneralCeremonyTicket: "General Ceremony Ticket",
        VIPCeremonyTicket: "VIP Ceremony Ticket",
    },
    HumpdayGiveaway: {
        HumpdayGiveawayBase: "Standard Humpday Giveaway",
    },
    Magazine: {
        PrintedMagazine: "Magazine",
    },
    MagazineDeposit: {
        MagazineDoubleDeposit: "Double Your Magazine Deposit",
    },
    MagazineAd: {
        QuarterPageAd: "Quarter Page Ad",
        HalfPageAd: "Half Page Ad",
        FullPageAd: "Full Page Ad",
    },
    MagazineAdDeposit: {
        DoubleDeposit: "Double Your Deposit",
    },
    MagazineArticle: {
        QuarterPageArticle: "Quarter Page Article",
        HalfPageArticle: "Half Page Article",
        FullPageArticle: "Full Page Article",
        SpotlightArticle: "Spotlight Article",
    },
    Plaque: {
        EngravedPlaque: "Engraved Plaque",
        PreviousYearPlaque: "Previous Year Plaque",
    },
    VotingStageSponsorship: {
        VotingStageSponsorshipBase: "Standard Voting Stage Sponsorship",
    },
    VoterRewards: {
        VoterRewardsBase: "Standard Voter Rewards",
    },
    Upgrade: {
        VIPUpgrade: "Upgrade tickets to V.I.P.",
    },
};
export const ProductAvailability = {
    Always: "Always",
    DateRange: "DateRange",
};
export const Selectables = {
    AwardYear: "Award Year",
    Category: "Category",
    CategoryId: "CategoryId",
};
//# sourceMappingURL=products.js.map